import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "none",
  viewBox: "0 0 100.71 100.71"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m.35.35 100 100M100.35.35l-100 100",
      "vector-effect": "non-scaling-stroke"
    }, null, -1)
  ]))]))
}
export default { render: render }